import React from 'react';
import ScheduleEditor from '@/components/displays/ScheduleEditor';
import { EnhancedSchedule, DisplaySchedule } from '@/types/display';

interface AdvancedScheduleTabProps {
  schedule: DisplaySchedule;
  city?: string | null;
  state?: string | null;
  onChange: (schedule: EnhancedSchedule) => void;
}

/**
 * Advanced Schedule Tab - wraps the existing ScheduleEditor component
 * This provides the full-featured schedule editor with:
 * - Timezone configuration
 * - Per-day hour settings
 * - Date-specific overrides
 * - Season date ranges
 * - Quick hour presets
 * - Preview functionality
 */
const AdvancedScheduleTab: React.FC<AdvancedScheduleTabProps> = ({
  schedule,
  city,
  state,
  onChange,
}) => {
  return (
    <div className="space-y-4">
      <div className="text-sm text-muted-foreground mb-4">
        Advanced scheduling allows you to set different hours for each day of the week,
        create date-specific overrides, and manage timezone settings.
      </div>
      <ScheduleEditor
        schedule={schedule}
        city={city}
        state={state}
        onChange={onChange}
      />
    </div>
  );
};

export default AdvancedScheduleTab;
